// ── Geteilter Overlay-Header — EINE red.-Sprache für alle Modals/Sheets ──────
// Kicker (muted, caps) · Display-Headline · roter 46px-Akzent-Strich (#B33E3A)
// · neutraler runder Close mit subtiler organischer Motion (BG-Fill + Press-
// Squish). Spiegelt BrandModal/WizardSheet — damit jedes Overlay gleich wirkt.
import { F } from '../../styles/theme';
import { useTheme } from '../../context/ThemeContext';

const RED_ACCENT = '#B33E3A';

// Runder Chrome-Button (Close / Back) — sanfter BG-Fill statt Border-Snap +
// weiches Press-Squish mit leichtem Überschwung.
export function OverlayCloseBtn({ onClick, label = 'Schließen', back = false, size = 32 }) {
  const { T } = useTheme();
  const path = back ? 'M15 18l-6-6 6-6' : 'M18 6L6 18M6 6l12 12';
  return (
    <button
      onClick={onClick}
      aria-label={label}
      className={back ? undefined : 'mo-close'}
      onMouseEnter={e => { e.currentTarget.style.background = T.itemHover; e.currentTarget.style.color = T.text; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = T.sub; e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseDown={e => { e.currentTarget.style.transform = 'scale(0.88)'; }}
      onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      style={{
        width: size, height: size, flexShrink: 0,
        background: 'transparent', border: `1px solid ${T.line}`, color: T.sub,
        borderRadius: 999, cursor: 'pointer', padding: 0,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        WebkitTapHighlightColor: 'transparent',
        transition: 'background 200ms ease, color 200ms ease, transform 200ms cubic-bezier(.34,1.5,.5,1)',
      }}
    >
      <svg className={back ? undefined : 'mo-close-ico'}
        width={Math.round(size * 0.42)} height={Math.round(size * 0.42)} viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d={path} />
      </svg>
    </button>
  );
}

// Vereinheitlichter Header. `onBack` blendet links einen Back-Button ein,
// `right` ersetzt den Close-Slot (z.B. für eigene Stat-Blöcke).
export function OverlayHeader({ kicker, title, sub, onClose, onBack, right, hairline = false, titleSize = 25 }) {
  const { T } = useTheme();
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 14 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, minWidth: 0 }}>
          {onBack && <OverlayCloseBtn onClick={onBack} label="Zurück" back />}
          <div style={{ minWidth: 0 }}>
            {kicker && (
              <div style={{
                fontFamily: F.family, fontSize: 10, fontWeight: 700,
                letterSpacing: '0.2em', textTransform: 'uppercase', color: T.mute || T.sub,
              }}>{kicker}</div>
            )}
            {title && (
              <h2 style={{
                margin: kicker ? '6px 0 0' : 0,
                fontFamily: F.display, fontSize: titleSize, fontWeight: 800,
                letterSpacing: '-0.035em', lineHeight: 1.05, color: T.text,
              }}>{title}</h2>
            )}
            {title && (
              <div aria-hidden style={{ width: 46, height: 3, borderRadius: 2, background: RED_ACCENT, marginTop: 10 }} />
            )}
          </div>
        </div>
        {right !== undefined ? right : (onClose && <OverlayCloseBtn onClick={onClose} />)}
      </div>

      {sub && (
        <div style={{ fontSize: 12.5, color: T.sub, lineHeight: 1.55, marginTop: 12, maxWidth: 420 }}>
          {sub}
        </div>
      )}

      {hairline && <div aria-hidden style={{ height: 1, background: T.line, margin: '18px 0' }} />}
    </>
  );
}

export default OverlayHeader;
